import React from 'react';
import {BenchmarkLegend as SharedBenchmarkLegend} from '../../DashboardCommon/widgets.comp';

/* The Network dashboard's widgets live in `pages/DashboardCommon/widgets.comp.jsx`
   (one copy for School, Network and Partner). This file keeps the Network
   default so its importers do not change. */
export * from '../../DashboardCommon/widgets.comp';

export const BenchmarkLegend = (props) => <SharedBenchmarkLegend seriesLabel="Network score" {...props}/>;
